import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetOnePodcast(data = {}) {
  const { enabled = false, queryParams = '', configs = {}, podcastId } = data;
  const { params = {} } = configs;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function getOnePodcast() {
    return privateFetch.get(`/v1/admin/podcast/${podcastId}`);
  }
  return useQuery(['podcast', params], getOnePodcast, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetOnePodcast;
